/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import { Subtype } from '@scenario/models/subtype.model';
import { retrieveSubtypesFailure, retrieveSubtypesSuccess } from '@store/scenario/subtypes/subtypes-slice';

export const retrieveSubtypesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('subtypes/retrieveSubtypes'),
    concatMap((_action: Action) =>
      from(dependencies.subtypeGateway.retrieveAll()).pipe(
        map((subtypes: Subtype[]) => retrieveSubtypesSuccess(subtypes)),
        catchError(() => of(retrieveSubtypesFailure('Fail to retrieve subtypes'))),
      ),
    ),
  );
